<div class="pagination">
  <div
    class="paginator"
    *ngIf="totalPages !== 0">
    <button
      class="paginator__arrow paginator__arrow--double paginator__arrow--double-first"
      [disabled]="prevDisabled()"
      [ngClass]="{ 'paginator__arrow--disabled': prevDisabled() }"
      (click)="goFirstPage()">
      <i class="icon-small-arrow-left"></i>
      <i class="icon-small-arrow-left"></i>
    </button>
    <button
      class="paginator__arrow"
      [disabled]="prevDisabled()"
      (click)="prevPage()"
      [ngClass]="{ 'paginator__arrow--disabled': prevDisabled() }">
      <i class="icon-small-arrow-left"></i>
    </button>
    <ul class="paginator__nav">
      <li *ngFor="let p of pages">
        <a
          class="paginator__nav"
          (click)="goToPage(p)"
          [ngClass]="{ 'paginator__nav--active': p === pagination.page }"
          (click)="goToPage(p)">
          {{ p + 1 }}
        </a>
      </li>
    </ul>
    <button
      class="paginator__arrow"
      [disabled]="nextDisabled()"
      (click)="nextPage()"
      [ngClass]="{ 'paginator__arrow--disabled': nextDisabled() }">
      <i class="icon-small-arrow-right"></i>
    </button>
    <button
      class="paginator__arrow paginator__arrow--double paginator__arrow--double-last"
      [disabled]="nextDisabled()"
      [ngClass]="{ 'paginator__arrow--disabled': nextDisabled() }"
      (click)="goLastPage()">
      <i class="icon-small-arrow-right"></i>
      <i class="icon-small-arrow-right"></i>
    </button>
  </div>
  <div
    class="vox-pagination__paginate-size paginate-size"
    *ngIf="!pagination.hidePageSize">
    <span class="paginate-size__label">{{ "shared.pagination.pages-label" | Translate }}</span>
    <div
      ngbDropdown
      class="vox-dropdown-input paginate-size__dropdown"
      placement="top">
      <button
        class="paginate-size__toggle"
        id="paginate-size"
        ngbDropdownToggle>
        {{ pagination.pageSize || selectedPageSize }}
      </button>
      <div
        ngbDropdownMenu
        aria-labelledby="paginate-size">
        <button
          ngbDropdownItem
          *ngFor="let size of pageSizes"
          (click)="selectPageSize(size)">
          {{ size }}
        </button>
      </div>
    </div>
  </div>
</div>
